import '../../node_modules/jquery-ui-slider-pips-npm/src/js/jquery-ui-slider-pips.js';
import Portfolio from './_portfolio';
import Layout from './_layout';

import '../scss/layout.scss';

const $ = jQuery.noConflict();

$(function() {
  new Layout();
  new Portfolio();
});
